import { OnInit } from '@angular/core';
var PictureComponent = /** @class */ (function () {
    function PictureComponent() {
        this.scale = 100;
        this.isIE11 = false;
    }
    Object.defineProperty(PictureComponent.prototype, "className", {
        get: function () { return this.isSvg() ? 'picture--svg' : 'picture'; },
        enumerable: true,
        configurable: true
    });
    ;
    PictureComponent.prototype.ngOnInit = function () {
        if (!this.data)
            return;
        this.isIE11 = this.checkIE11();
        this.updateInlineStyles();
    };
    PictureComponent.prototype.updateInlineStyles = function () {
        var width = 'auto';
        var maxWidth = '100%';
        if (this.scale < 100 && !this.isSvg()) {
            width = this.scale + "%";
        }
        if (this.isSvg()) {
            width = this.scale / 3 + "%";
        }
        this.style = { width: width, maxWidth: maxWidth };
    };
    PictureComponent.prototype.isSvg = function () {
        return !!this.data.src.match(/\.svg$/);
    };
    PictureComponent.prototype.checkIE11 = function () {
        var ua = window.navigator.userAgent;
        var trident = ua.indexOf('Trident/');
        if (trident > 0) {
            var rv = ua.indexOf('rv:');
            return !!parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
        }
    };
    return PictureComponent;
}());
export { PictureComponent };
